export function formatRupiah(n) {
  const num = Number(n) || 0;
  return "Rp " + Math.round(num).toLocaleString("id-ID");
}

export function formatBulan(ym) {
  if (!ym) return "-";
  const [y, m] = ym.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
  const idx = parseInt(m, 10) - 1;
  return `${names[idx] || m} ${y}`;
}
